// Task Rule CRUD
export const GET_TASK_RULES_REQUEST = 'GET_TASK_RULES_REQUEST';
export const GET_TASK_RULES_SUCCESS = 'GET_TASK_RULES_SUCCESS';
export const GET_TASK_RULES_FAILURE = 'GET_TASK_RULES_FAILURE';

export const GET_TASK_RULE_REQUEST = 'GET_TASK_RULE_REQUEST';
export const GET_TASK_RULE_SUCCESS = 'GET_TASK_RULE_SUCCESS';
export const GET_TASK_RULE_FAILURE = 'GET_TASK_RULE_FAILURE';

export const CREATE_TASK_RULE_REQUEST = 'CREATE_TASK_RULE_REQUEST';
export const CREATE_TASK_RULE_SUCCESS = 'CREATE_TASK_RULE_SUCCESS';
export const CREATE_TASK_RULE_FAILURE = 'CREATE_TASK_RULE_FAILURE';

export const UPDATE_TASK_RULE_REQUEST = 'UPDATE_TASK_RULE_REQUEST';
export const UPDATE_TASK_RULE_SUCCESS = 'UPDATE_TASK_RULE_SUCCESS';
export const UPDATE_TASK_RULE_FAILURE = 'UPDATE_TASK_RULE_FAILURE';

export const DELETE_TASK_RULE_REQUEST = 'DELETE_TASK_RULE_REQUEST';
export const DELETE_TASK_RULE_SUCCESS = 'DELETE_TASK_RULE_SUCCESS';
export const DELETE_TASK_RULE_FAILURE = 'DELETE_TASK_RULE_FAILURE';

// Trigger Conditions
export const GET_RULE_CONDITIONS_REQUEST = 'GET_RULE_CONDITIONS_REQUEST';
export const GET_RULE_CONDITIONS_SUCCESS = 'GET_RULE_CONDITIONS_SUCCESS';
export const GET_RULE_CONDITIONS_FAILURE = 'GET_RULE_CONDITIONS_FAILURE';

export const ADD_RULE_CONDITION_REQUEST = 'ADD_RULE_CONDITION_REQUEST';
export const ADD_RULE_CONDITION_SUCCESS = 'ADD_RULE_CONDITION_SUCCESS';
export const ADD_RULE_CONDITION_FAILURE = 'ADD_RULE_CONDITION_FAILURE';

export const DELETE_RULE_CONDITION_REQUEST = 'DELETE_RULE_CONDITION_REQUEST';
export const DELETE_RULE_CONDITION_SUCCESS = 'DELETE_RULE_CONDITION_SUCCESS';
export const DELETE_RULE_CONDITION_FAILURE = 'DELETE_RULE_CONDITION_FAILURE';

// Client Inclusions
export const GET_RULE_CLIENTS_REQUEST = 'GET_RULE_CLIENTS_REQUEST';
export const GET_RULE_CLIENTS_SUCCESS = 'GET_RULE_CLIENTS_SUCCESS';
export const GET_RULE_CLIENTS_FAILURE = 'GET_RULE_CLIENTS_FAILURE';

export const ADD_RULE_CLIENT_REQUEST = 'ADD_RULE_CLIENT_REQUEST';
export const ADD_RULE_CLIENT_SUCCESS = 'ADD_RULE_CLIENT_SUCCESS';
export const ADD_RULE_CLIENT_FAILURE = 'ADD_RULE_CLIENT_FAILURE';

export const DELETE_RULE_CLIENT_REQUEST = 'DELETE_RULE_CLIENT_REQUEST';
export const DELETE_RULE_CLIENT_SUCCESS = 'DELETE_RULE_CLIENT_SUCCESS';
export const DELETE_RULE_CLIENT_FAILURE = 'DELETE_RULE_CLIENT_FAILURE';

// Valid Trigger Fields
export const GET_VALID_TRIGGER_FIELDS_REQUEST = 'GET_VALID_TRIGGER_FIELDS_REQUEST';
export const GET_VALID_TRIGGER_FIELDS_SUCCESS = 'GET_VALID_TRIGGER_FIELDS_SUCCESS';
export const GET_VALID_TRIGGER_FIELDS_FAILURE = 'GET_VALID_TRIGGER_FIELDS_FAILURE';

// Trigger Services (Task.TaskTriggerServiceGroup catalog)
export const GET_TASK_TRIGGER_SERVICES_REQUEST = 'GET_TASK_TRIGGER_SERVICES_REQUEST';
export const GET_TASK_TRIGGER_SERVICES_SUCCESS = 'GET_TASK_TRIGGER_SERVICES_SUCCESS';
export const GET_TASK_TRIGGER_SERVICES_FAILURE = 'GET_TASK_TRIGGER_SERVICES_FAILURE';

// Probe: same trigger-fields endpoint at segment level, used only to learn which services have segment tables
export const PROBE_SEGMENT_TABLES_REQUEST = 'PROBE_SEGMENT_TABLES_REQUEST';
export const PROBE_SEGMENT_TABLES_SUCCESS = 'PROBE_SEGMENT_TABLES_SUCCESS';
export const PROBE_SEGMENT_TABLES_FAILURE = 'PROBE_SEGMENT_TABLES_FAILURE';

// Generate Tasks
export const GENERATE_TASKS_FOR_RULE_REQUEST = 'GENERATE_TASKS_FOR_RULE_REQUEST';
export const GENERATE_TASKS_FOR_RULE_SUCCESS = 'GENERATE_TASKS_FOR_RULE_SUCCESS';
export const GENERATE_TASKS_FOR_RULE_FAILURE = 'GENERATE_TASKS_FOR_RULE_FAILURE';

export const GENERATE_TASKS_ALL_RULES_REQUEST = 'GENERATE_TASKS_ALL_RULES_REQUEST';
export const GENERATE_TASKS_ALL_RULES_SUCCESS = 'GENERATE_TASKS_ALL_RULES_SUCCESS';
export const GENERATE_TASKS_ALL_RULES_FAILURE = 'GENERATE_TASKS_ALL_RULES_FAILURE';

// Relocation Policies
export const GET_RELO_POLICIES_BY_CLIENT_REQUEST = 'GET_RELO_POLICIES_BY_CLIENT_REQUEST';
export const GET_RELO_POLICIES_BY_CLIENT_SUCCESS = 'GET_RELO_POLICIES_BY_CLIENT_SUCCESS';
export const GET_RELO_POLICIES_BY_CLIENT_FAILURE = 'GET_RELO_POLICIES_BY_CLIENT_FAILURE';

// Local state management
export const CLEAR_CURRENT_RULE = 'CLEAR_CURRENT_RULE';
export const CLEAR_VALID_TRIGGER_FIELDS = 'CLEAR_VALID_TRIGGER_FIELDS';
export const SET_RULE_FORM_FIELD = 'SET_RULE_FORM_FIELD';
export const RESET_RULE_FORM = 'RESET_RULE_FORM';
